import InfoBox from "common-ui-components/components/info-box/InfoBox";
import React, { useCallback, useEffect, useState } from "react";
import HeatMap from "common-ui-components/components/heat-map/HeatMap";
import API from "common-ui-components/components/utils/API";
import styles from "./Threats.module.css";

const VulnerabilityMatrix = () => {
  const [matrix, setMatrix] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMatrix = useCallback(async (signal) => {
    try {
      const response = await API.get(
        "/inventory/vuln-age-severity/heatmap",
        { signal },
      );
      if (!signal.aborted && response?.status?.success) {
        setMatrix(response.body || null);
      }
    } catch (error) {
      if (!signal.aborted) {
        console.error("Failed to load vulnerability age heatmap:", error);
      }
    } finally {
      if (!signal.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchMatrix(controller.signal);
    return () => controller.abort();
  }, [fetchMatrix]);

  return (
    <div>
      <InfoBox
        header={matrix?.title || "Vulnerability Age Matrix"}
        subtitle="How long open vulnerabilities have been outstanding"
        badge={loading ? "Loading" : `${(matrix?.grandTotal ?? 0).toLocaleString()} missing`}
        badgeProps={{ style: { background: "#fdf0d5", color: "#92400e" } }}
        style={{ width: "100%", minWidth: 0 }}
      >
        {!loading && !matrix ? (
          <div role="alert" className={styles.matrixEmpty}>Unable to load the vulnerability age heatmap.</div>
        ) : (
          <HeatMap
            data={matrix}
            isLoading={loading}
            footnote="Cell color fades from the upper-left to the lower-right"
          />
        )}
      </InfoBox>
    </div>
  );
};

export default VulnerabilityMatrix;
